import React from "react";

import l10n from "../../l10n/localization";
import Tabs from "react-toolbox/lib/tabs/Tabs";
import Tab from "react-toolbox/lib/tabs/Tab";
import ClientForm from "../forms/ClientForm";
import ContactTable from "./contact/ContactTable";
import ClientRateTable from "./clientRate/ClientRateTable";
import {Button} from "react-materialize";
import ClientContactForm from "../forms/ClientContactForm";
import ClientRateForm from "../forms/ClientRateForm";
import * as creationActions from "../../actions/creation";
import * as utilsCommon from "../../utils/utils";
import {connect} from "react-redux";

class ClientTabs extends React.Component {

    state = {
        activeTab: 0,
    };


    handleTabChange = (activeTab) => {
        this.setState({activeTab});
    };

    render() {
        let client = null;
        let isNew = false;

        if ((!utilsCommon.notNullNorUndefined(this.props.item) || !utilsCommon.notNullNorUndefined(this.props.item.item) || !utilsCommon.notNullNorUndefined(this.props.item.item.id)) && this.props.newlyCreatedElement === null) {
            isNew = true;
        } else {
            client = {...this.props.item.item};
            if (this.props.newlyCreatedElement !== null) {
                client = this.props.clients.getById(this.props.newlyCreatedElement);
                if (!utilsCommon.notNullNorUndefined(client)) {
                    isNew = true;
                }
            } else {
                if (utilsCommon.notNullNorUndefined(this.props.item) && utilsCommon.notNullNorUndefined(this.props.item.item)) {
                    client = this.props.clients.getById(this.props.item.item.id);
                }
            }
        }

        return (
            <section className="client-tabs">
                {!isNew && <h1>Client</h1>}
                {isNew && <h1>New Client</h1>}
                <Tabs index={this.state.activeTab} onChange={this.handleTabChange}>
                    <Tab label={l10n.common.general} ><ClientForm item={client} depth={this.props.depth} openDrawer={this.props.openDrawer} /></Tab>
                    <Tab label={l10n.common.contacts} disabled={isNew}>
                        {!isNew && (<div><ContactTable client={client} depth={this.props.depth} openDrawer={this.props.openDrawer} />
                        <br />
                        <Button floating onClick={() => this.props.openDrawer(ClientContactForm, {item: null, client: client}, creationActions.destroyingnewlyCreatedClientContact())} icon="add" className="add-button" /></div>)}
                    </Tab>
                    <Tab label={l10n.common.clientRates} disabled={isNew}>
                        {!isNew && (<div><ClientRateTable client={client} depth={this.props.depth} openDrawer={this.props.openDrawer} />
                        <br />
                        <Button floating onClick={() => this.props.openDrawer(ClientRateForm, {item: null, client: client}, creationActions.destroyingnewlyCreatedClientRate())} icon="add" className="add-button" /></div>)}
                    </Tab>
                </Tabs>
            </section>
        )
    }
};

export default connect((state) => {
    return Object.assign({}, {
        newlyCreatedElement: state.creation.newlyCreatedClient,
        clients: state.client.clients,
    });
})(ClientTabs);


// WEBPACK FOOTER //
// ./src/components/client/ClientTabs.js